import { render, staticRenderFns } from "./CitationModal.vue?vue&type=template&id=71b47a76&scoped=true&"
import script from "./CitationModal.vue?vue&type=script&lang=ts&"
export * from "./CitationModal.vue?vue&type=script&lang=ts&"
import style0 from "./CitationModal.vue?vue&type=style&index=0&id=71b47a76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b47a76",
  null
  
)

export default component.exports